import React from 'react';

export default function FileTypeSpreadsheetIcon() {
    return <svg width="14" height="10" viewBox="0 0 14 10" fill="none" xmlns="http://www.w3.org/2000/svg"> <rect x="0.833008" y="0.5" width="12.3333" height="9" stroke="#2AC769"/> </svg> 
};